import * as React from 'react';
import {Link} from 'gatsby';
import {b1, h4} from 'constants/fonts';
import Flex from 'layout/Flex';

type Category = {
  anchor:
    | 'video'
    | 'photography'
    | 'textile'
    | 'written-word'
    | 'sound'
    | 'sculpture'
    | 'mixed-media'
    | 'drawing'
    | 'painting';
  category:
    | 'video'
    | 'photography'
    | 'textile'
    | 'writtenWord'
    | 'sound'
    | 'sculpture'
    | 'mixedMedia'
    | 'drawing'
    | 'painting';
  count: number;
  imageSrc: string;
};
type Props = {categories: Category[]};

export default function WorkCategories({categories}: Props) {
  return (
    <Flex center direction="column">
      {categories.map(({anchor, category, count, imageSrc}) => {
        return (
          <Link css={{position: 'relative'}} key={category + count + imageSrc} to={`/works#${anchor}`}>
            <Flex center css={{justifyContent: 'flex-start', marginBottom: 24}}>
              <img
                css={{
                  objectFit: 'contain',
                  objectPosition: 'center',
                  height: '100%',
                  width: '55%',
                  maxHeight: '70vh',
                  position: 'relative',
                }}
                key={category}
                src={imageSrc}
              />
              <Flex direction="column">
                <h3
                  css={[
                    h4,
                    {
                      marginLeft: 16,
                      textDecoration: 'none',
                      textTransform: 'capitalize',
                    },
                  ]}
                >
                  {category}
                </h3>
                <p
                  css={({color}) => [
                    b1,
                    {
                      color: color.lightRed,
                      fontSize: 14,
                      marginLeft: 16,
                      textDecoration: 'none',
                    },
                  ]}
                >
                  {count} work{count > 1 && 's'}
                </p>
              </Flex>
            </Flex>
          </Link>
        );
      })}
    </Flex>
  );
}
